/**
 * @generated SignedSource<<e2ef2a462905c918c1c5bc374ee9fda5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SlotAvailability = "ACCESSIBLE" | "ACCESSIBLE_BOOKING" | "AVAILABLE" | "AVAILABLE_AFTER_START" | "BLOCKED" | "BLOCKED_BY_BLOCK" | "BLOCKED_BY_BOOKING" | "BLOCKED_BY_EVENT" | "FREE" | "UNAVAILABLE";
import { FragmentRefs } from "relay-runtime";
export type useValidDurationsNode$data = {
  readonly endSlotOptions?: {
    readonly edges: ReadonlyArray<{
      readonly allowedPlayerCounts: ReadonlyArray<number | null | undefined> | null | undefined;
      readonly durationMins: number | null | undefined;
      readonly node: {
        readonly availability: SlotAvailability;
        readonly id: string;
        readonly time: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useValidDurationsNode";
};
export type useValidDurationsNode$key = {
  readonly " $data"?: useValidDurationsNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"useValidDurationsNode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "bookingId"
    },
    {
      "kind": "RootArgument",
      "name": "bookingType"
    },
    {
      "kind": "RootArgument",
      "name": "memberId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useValidDurationsNode",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "bookingId",
              "variableName": "bookingId"
            },
            {
              "kind": "Variable",
              "name": "bookingType",
              "variableName": "bookingType"
            },
            {
              "kind": "Variable",
              "name": "memberId",
              "variableName": "memberId"
            }
          ],
          "concreteType": "EndSlotOptionsConnection",
          "kind": "LinkedField",
          "name": "endSlotOptions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EndSlotOptionsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "durationMins",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "allowedPlayerCounts",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TimeSlot",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "time",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "availability",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "TimeSlot",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "6119f7153a92d98a346417446cb26af3";

export default node;
